import { VisioService } from '@agent/core/channel-digit/visio/visio.service';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'cng-visio-main-stream',
  templateUrl: 'visio-main-stream.component.html',
  styleUrls: ['./visio-main-stream.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class VisioMainStreamComponent implements OnInit, OnChanges {
  @ViewChild('visioMainStreamContainer', { static: true }) visioMainStreamContainer: ElementRef;
  @Input() stream: OT.Stream;

  subscriber: OT.Subscriber | undefined = undefined;

  constructor(private readonly visioService: VisioService) {}

  ngOnInit() {
    if (!!this.stream) {
      if (!!this.subscriber) {
        this.visioService.unsubscribe(this.subscriber);
      }
      this.subscriber = this.visioService.subscribe(this.stream, this.visioMainStreamContainer, true);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { ['stream']: entries } = changes;
    if (!(entries && entries.currentValue && entries.previousValue !== entries.currentValue)) {
      return;
    }

    if (!!this.subscriber) {
      this.visioService.unsubscribe(this.subscriber);
    }
    this.subscriber = this.visioService.subscribe(this.stream, this.visioMainStreamContainer, true);
  }

  getTitle(stream: OT.Stream): string {
    if (!stream) {
      return 'agent:panel.visio.loading';
    } else if (stream.connection && stream.connection.data) {
      let data = JSON.parse(stream.connection.data.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
      let username = data.username;

      if (stream.videoType === 'screen') {
        return 'agent:panel.visio.screenSharing';
      } else {
        return username;
      }
    }
    return 'agent:panel.visio.screenSharing';
  }

  getTitleIcon(stream: OT.Stream): string | undefined {
    if (!stream) {
      return;
    }
    if (stream.videoType === 'screen') {
      return 'screenSharing';
    }
    return undefined;
  }
}
